module.exports = __webpack_public_path__ + "img/1192764808.26d7bd55.png";